import { snakeCase } from 'lodash'

import i18n from 'modules/core/lib/i18n'

export const typeFilterLabelTranslations = (key: string) => {
  const formattedKey = snakeCase(key)

  switch (formattedKey) {
    case 'all_leaves':
      return i18n.t('bookkeepers.incidence.filters.types.all_leaves')
    case 'all_terminations':
      return i18n.t('bookkeepers.incidence.filters.types.all_terminations')
    case 'cost_center':
      return i18n.t('bookkeepers.incidence.filters.types.cost_center')
    case 'termination':
      return i18n.t('bookkeepers.incidence.filters.types.termination')
    case 'sick':
      return i18n.t('bookkeepers.incidence.filters.types.sick')
    case 'parental':
      return i18n.t('bookkeepers.incidence.filters.types.parental')
    case 'custom_leave':
      return i18n.t('bookkeepers.incidence.filters.types.custom_leave')
    case 'all_contracts':
      return i18n.t('bookkeepers.incidence.filters.types.all_contracts')
    case 'contract':
      return i18n.t('bookkeepers.incidence.filters.types.contract')
    case 'all_personal_data':
      return i18n.t('bookkeepers.incidence.filters.types.all_personal_data')
    case 'name':
      return i18n.t('bookkeepers.incidence.filters.types.name')
    case 'id':
      return i18n.t('bookkeepers.incidence.filters.types.id')
    case 'identification':
      return i18n.t('bookkeepers.incidence.filters.types.id')
    case 'address':
      return i18n.t('bookkeepers.incidence.filters.types.address')
    case 'irpf':
      return i18n.t('bookkeepers.incidence.filters.types.irpf')
    case 'bank':
      return i18n.t('bookkeepers.incidence.filters.types.bank')
    case 'legal_entity':
      return i18n.t('bookkeepers.incidence.filters.types.legal_entity')
    case 'nationality':
      return i18n.t('bookkeepers.incidence.filters.types.nationality')
    case 'gender':
      return i18n.t('bookkeepers.incidence.filters.types.gender')
    case 'hiring':
      return i18n.t('bookkeepers.incidence.filters.types.hiring')
    case 'residence':
      return i18n.t('bookkeepers.incidence.filters.types.residence')
    case 'workplace':
      return i18n.t('bookkeepers.incidence.filters.types.workplace')
    case 'email':
      return i18n.t('bookkeepers.incidence.filters.types.email')
    case 'all_manual_incidences':
      return i18n.t('bookkeepers.incidence.filters.types.all_manual_incidences')
    case 'manual_incidence':
      return i18n.t('bookkeepers.incidence.filters.types.manual_incidence')
    case 'absence':
      return i18n.t('bookkeepers.incidence.filters.types.absence')
    case 'personal_data':
      return i18n.t('bookkeepers.incidence.filters.types.personal_data')
    case 'phone_number':
      return i18n.t('bookkeepers.incidence.filters.types.phone_number')
    case 'all_hiring':
      return i18n.t('bookkeepers.incidence.filters.types.all_hiring')
    case 'others':
      return i18n.t('bookkeepers.incidence.filters.types.others')
    default:
      throw new Error(`Missing translation for incidence.filters.types.${key}`)
  }
}
